import { useParams, useQueryParams } from '@atlassian/mpac-ui';
import invariant from 'invariant';
import React from 'react';
import ReportDetails from "./ReportDetails";

const ReportDetailsContainer = props => {
  const sourceParams = useQueryParams();
  const {
    reportName,
    text
  } = useParams();
  invariant(text, 'text filter is required');
  invariant(reportName, 'Report name is required');
  return /*#__PURE__*/React.createElement(ReportDetails, {
    partnerName: props.partnerDetails.name,
    mpacBaseUrl: props.mpacBaseUrl,
    partnerId: props.partnerId,
    sourceParams: sourceParams,
    textParams: {
      text
    },
    reportName: reportName
  });
};

export default ReportDetailsContainer;